import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest,} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from "../../../../environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const access_token = localStorage.getItem('access_token') ?? '';
    const company_code = localStorage.getItem('company_code') ?? '';
    const refresh_token = localStorage.getItem('refresh_token') ?? '';
    const bearerToken = req.url === `${environment.baseUrl}/refresh/token` ? refresh_token : access_token;

    // Clone the request and set headers if needed

    const authReq = req.clone({
      headers: req.headers
        .set('Authorization', `Bearer ${bearerToken}`)
        .set('X-Company', `${company_code}`),
    });
    // Pass the cloned request with headers to the next handler
    return next.handle(authReq);
  }
}
